import {
  CalendarPlus,
  Users,
  CalendarClock,
  Megaphone,
  CalendarX,
  DollarSign,
  MessageSquare,
  Gift,
  Star,
  Building2,
  Settings,
  Mail,
  MailCheck,
  Bug,
  FileText,
  ClipboardList,
  BarChart3,
  PackageOpen,
  Handshake,
  GraduationCap,
  ListChecks,
  NotebookPen,
} from "lucide-react";
import DashboardCard from "@/components/admin/DashboardCard";

export default function AdminDashboard() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold text-foreground mb-8">
        Admin Dashboard
      </h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <DashboardCard
          title="Manage Events"
          description="View and manage existing events"
          icon={CalendarClock}
          linkTo="/admin/events"
          buttonText="View Events"
        />

        <DashboardCard
          title="Active Bids"
          description="View and manage incoming bid requests"
          icon={MessageSquare}
          linkTo="/admin/bids"
          buttonText="View Bids"
        />

        <DashboardCard
          title="Manage Employees"
          description="View and manage employee information"
          icon={Users}
          linkTo="/admin/employees"
          buttonText="View Employees"
        />

        <DashboardCard
          title="Pricing"
          description="Manage table prices and employee requirements"
          icon={DollarSign}
          linkTo="/admin/pricing"
          buttonText="Manage Pricing"
        />

        <DashboardCard
          title="Create Event"
          description="Create and schedule new casino events"
          icon={CalendarPlus}
          linkTo="/admin/events/create"
          buttonText="Create New Event"
        />

        <DashboardCard
          title="Manage Seniority"
          description="Configure employee seniority levels and notification delays"
          icon={Star}
          linkTo="/admin/seniority"
          buttonText="Manage Seniority Levels"
        />

        <DashboardCard
          title="Manage Bonuses"
          description="Set up and manage employee bonus programs"
          icon={Gift}
          linkTo="/admin/bonuses"
          buttonText="View Bonuses"
        />

        <DashboardCard
          title="Earned Bonuses"
          description="View and manage earned bonus records, mark as paid"
          icon={ListChecks}
          linkTo="/admin/earned-bonuses"
          buttonText="View Earned Bonuses"
        />

        <DashboardCard
          title="Special Announcements"
          description="Create and manage special announcements"
          icon={Megaphone}
          linkTo="/admin/announcements"
          buttonText="Manage Announcements"
        />

        <DashboardCard
          title="Manage Clients"
          description="View and manage client information"
          icon={Building2}
          linkTo="/admin/clients"
          buttonText="View Clients"
        />

        <DashboardCard
          title="Full Dates"
          description="Mark dates as fully booked so the bid request form says so"
          icon={CalendarX}
          linkTo="/admin/full-dates"
          buttonText="Manage Full Dates"
        />

        <DashboardCard
          title="Settings"
          description="Configure system-wide settings and preferences"
          icon={Settings}
          linkTo="/admin/settings"
          buttonText="Manage Settings"
        />

        <DashboardCard
          title="Email Templates"
          description="Configure automatic email notifications"
          icon={Mail}
          linkTo="/admin/email-templates"
          buttonText="Manage Templates"
        />

        <DashboardCard
          title="Notification Logs"
          description="View and manage sent and scheduled notifications"
          icon={MailCheck}
          linkTo="/admin/notification-logs"
          buttonText="View Logs"
        />

        <DashboardCard
          title="Sentry"
          description="Check if Sentry errors are passed through"
          icon={Bug}
          linkTo="/admin/sentry-test"
          buttonText="Test Sentry"
        />

        <DashboardCard
          title="Document Library"
          description="Upload and manage documents for digital signing"
          icon={FileText}
          linkTo="/admin/documents"
          buttonText="Manage Documents"
        />

        <DashboardCard
          title="Document Assignments"
          description="Assign documents to employees and track signing progress"
          icon={ClipboardList}
          linkTo="/admin/assignments"
          buttonText="Manage Assignments"
        />

        <DashboardCard
          title="Reports"
          description="Generate and view business reports and analytics"
          icon={BarChart3}
          linkTo="/admin/reports"
          buttonText="View Reports"
        />

        <DashboardCard
          title="Partner Management"
          description="Manage referral partners and track referral performance"
          icon={Handshake}
          linkTo="/admin/partners"
          buttonText="Manage Partners"
        />

        <DashboardCard
          title="Position Requests"
          description="Manage employee position learning requests"
          icon={GraduationCap}
          linkTo="/admin/position-requests"
          buttonText="View Requests"
        />

        <DashboardCard
          title="Journal"
          description="Event notes and the reminders you set yourself"
          icon={NotebookPen}
          linkTo="/admin/journal"
          buttonText="View Journal"
        />
      </div>
    </div>
  );
}
